import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns';
import generatePicker from 'antd/lib/date-picker/generatePicker';
import 'antd/es/date-picker/style/index';
import { vi } from "date-fns/locale";

const config = {
    ...dateFnsGenerateConfig,
    locale: {
        ...dateFnsGenerateConfig.locale,
        getShortWeekDays: () => {
            return Array.from({ length: 7 }).map((_, day) => {
                return vi.localize!.day(day, { width: "short" });
            });
        },
        getShortMonths: () => {
            return Array.from({ length: 12 }).map((_, month) =>
                vi.localize!.month(month, { width: "abbreviated" })
            );
        }
    }
}

const DatePicker = generatePicker<Date>(config);

export default DatePicker;